import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { User } from '@data/schema/user-state';
import { UserStoreService } from '../services/user-store.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(private router: Router, private userStore: UserStoreService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let userState: User = this.userStore.userState;
    if (!userState?.isAuthenticated) {
      this.router.navigate(['user/login'], {
        queryParams: { 'redirectURL': state.url },
      });
      return false;
    } else if (!userState?.isLegalAccepted) {
      this.router.navigate(['user/login'], {
        queryParams: { 'redirectURL': state.url },
      });
      return false;
    } else {
      return true;
    }
  }
}
